import { lazy } from 'react';

export const PlayerReportRgIndicatorForm = lazy(
  () => import('./PlayerReportRgIndicatorForm'),
);
